export enum DriverSelectionAlgorithm {
    Smart = 0,
    AbsDesc = 1,
    SeqDesc,
    SeqAsc,
}